export const VALIDATION_ERROR = 'Телефон введен некорректно';
